<header>
  <button app-burger>Menu</button>
  <a [routerLink]="'/'" class="logo">
    <img src="assets/images/logo.svg" alt="Logo" />
  </a>
</header>

<h1>Les chiffres clés emploi formation du BTP</h1>
<h2>
  <b>Visualisez, filtrez</b><i> et </i><b>exportez</b> les données statistiques
  <b>du BTP.</b>
</h2>
<div class="content">
  @if (figures) {
    <div class="cards" appUiTour="themes">
      <app-card
        icon="assets/images/icons/companies.svg"
        color="#9FC1EC"
        title="{{ Translations.HomeCompanies | translate }}"
        [values]="companies"></app-card>

      <app-card
        icon="assets/images/icons/employees.svg"
        color="#EDB34E"
        title="{{ Translations.HomeEmployees | translate }}"
        [values]="employees"></app-card>

      <app-card
        icon="assets/images/icons/interns.svg"
        color="#A7B85C"
        title="{{ Translations.HomeInternship | translate }}"
        [values]="interns"></app-card>

      <app-card
        icon="assets/images/icons/self-employed.svg"
        color="#D17151"
        title="{{ Translations.HomeSelfEmployed | translate }}"
        [values]="selfEmployed"></app-card>

      <app-card
        icon="assets/images/icons/work-studies.svg"
        color="#8AC0C0"
        title="{{ Translations.HomeWorkStudy | translate }}"
        [values]="workStudies"></app-card>

      <app-card
        icon="assets/images/icons/students.svg"
        color="#98A0C1"
        title="{{ Translations.HomeStudent | translate }}"
        [values]="students"></app-card>
    </div>
  }
  <h6>Les autres outils</h6>
  <div class="links">
    <a href="{{ Translations.HomeWebsiteLink | translate }}"
      >{{ Translations.HomeWebsite | translate }}
      <app-icon src="assets/images/icons/arrow.svg"></app-icon>
    </a>
    <a href="{{ Translations.HomeSituationLink | translate }}"
      >{{ Translations.HomeSituation | translate }}
      <app-icon src="assets/images/icons/arrow.svg"></app-icon>
    </a>
    <a href="{{ Translations.HomeNewsletterLink | translate }}"
      >{{ Translations.HomeNewsletter | translate }}
      <app-icon src="assets/images/icons/arrow.svg"></app-icon>
    </a>
    <a href="{{ Translations.HomeContactLink | translate }}"
      >{{ Translations.HomeContact | translate }}
      <app-icon src="assets/images/icons/arrow.svg"></app-icon>
    </a>
    <a [routerLink]="routes.legalNotice"
      >{{ Translations.HomeLegal | translate }}
      <app-icon src="assets/images/icons/arrow.svg"></app-icon>
    </a>
    <a (click)="startTour()" tabindex="0" (keydown.enter)="startTour()"
      >{{ Translations.HomeTour | translate }}
      <app-icon src="assets/images/icons/arrow.svg"></app-icon>
    </a>
  </div>
</div>
